import React from "react";
import styles from "./GrantsSection.module.scss";
import grantImage from "../../../assets/images/open-call-image.jpg";

const GrantsSection = () => {
  return (
    <div className={styles.grantsSection}>
      <div className={styles.titleContainer}>
        <div className="container">
          <h2 className={styles.title}>Grants</h2>
        </div>
      </div>
      <div className={styles.list}>
        {Array.from(Array(6), (_, index) => (
          <div className={styles.grant} key={index}>
            <img src={grantImage} alt="Title of the Grant for Artists 2025" />
            <div className={styles.grantTitle}>
              Title of the Grant for Artists 2025
            </div>
          </div>
        ))}
      </div>
      <div className={styles.otherListContainer}>
        <div className="container">
          <div className={styles.otherList}>
            {Array.from(Array(6), (_, index) => (
              <div className={styles.grantCard} key={index}>
                <div className={styles.grantInfo}>
                  <div className={styles.grantTitle}>
                    Title of the Grant for Artists 2025
                  </div>
                  <div className={styles.grantDesc}>
                    Contrary to popular belief, Lorem Ipsum is not simply random
                    text. It has roots in a piece of classical Latin literature
                    from 45 BC, making it over 2000 years old. Richard
                    McClintock. Contrary to popular belief, Lorem Ipsum is not
                    simply random text. It has roots in a piece of classical
                    Latin literature from. Contrary to popular belief, Lorem
                    Ipsum is not simply random text Contrary to popular belief,
                    Lorem Ipsum is not simple ...
                  </div>
                  <div className={styles.readMore}>Read More</div>
                </div>
                <div className={styles.grantImage}>
                  <img
                    src={grantImage}
                    alt="Title of the Grant for Artists 2025"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrantsSection;
